class LocalStorageFiltersService {
  /**
   * Obtiene la clave para el localStorage basada en la ruta actual
   * @param {Object} route - Objeto route de vue-router
   * @returns {string} Clave para el localStorage
   */
  getStorageKey(route) {
    // Para rutas personalizadas, usar el módulo y el ID de los parámetros
    if (route.name === 'custom-route') {
      return `filters_custom_${route.params.module}_${route.params.id}`;
    }

    // Para rutas base usar el nombre de la ruta
    const routeBase = `filters_${route.name}`;

    // Si hay parámetros relevantes (excluyendo timestamp), agregarlos a la clave
    const params = route.params || {};
    const relevantParams = Object.entries(params)
      .filter(([key]) => key !== 'timestamp') // Excluir timestamp
      .sort()
      .map(([key, value]) => `${key}:${value}`)
      .join('_');

    // Si hay parámetros relevantes, agregarlos a la clave
    return relevantParams ? `${routeBase}_${relevantParams}` : routeBase;
  }

  /**
   * Guarda los filtros en localStorage
   * @param {Object} route - Objeto route de vue-router
   * @param {Object} filters - Objeto con los filtros a guardar
   */
  saveFilters(route, filters) {
    const key = this.getStorageKey(route);
    localStorage.setItem(key, JSON.stringify(filters));
  }

  /**
   * Obtiene los filtros del localStorage
   * @param {Object} route - Objeto route de vue-router
   * @returns {Object|null} Objeto con los filtros o null si no existen
   */
  getFilters(route) {
    const key = this.getStorageKey(route);
    const filters = localStorage.getItem(key);
    return filters ? JSON.parse(filters) : null;
  }

  /**
   * Limpia los filtros del localStorage
   * @param {Object} route - Objeto route de vue-router 
   */
  clearFilters(route) {
    const key = this.getStorageKey(route);
    localStorage.removeItem(key);
  }

  /**
   * Actualiza parcialmente los filtros existentes
   * @param {Object} route - Objeto route de vue-router
   * @param {Object} newFilters - Nuevos valores de filtros a actualizar
   */
  updateFilters(route, newFilters) {
    const currentFilters = this.getFilters(route) || {};
    const updatedFilters = {
      ...currentFilters,
      ...newFilters
    };
    this.saveFilters(route, updatedFilters);
  }
}

export default new LocalStorageFiltersService();
